// eslint-disable-next-line
import { store } from '@/_store/';

export default [
  {
    path: '/',
    // redirect: '/login',
    component: () => import('@/pages/Home'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/activity',
    redirect: '/dashboard',
  },
  {
    path: '/clients',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'associate.clients',
        component: () => import('@/pages/associate/Clients/My'),
      },
      {
        path: 'all',
        name: 'associate.clients',
        component: () => import('@/pages/associate/Clients/Index'),
      },
      {
        path: 'my',
        name: 'associate.clients.my',
        component: () => import('@/pages/associate/Clients/My'),
      },
      {
        path: 'groups',
        name: 'associate.groups',
        component: () => import('@/pages/associate/Clients/Groups'),
      },
      {
        path: 'groups/:id',
        name: 'associate.groups.show',
        component: () => import('@/pages/associate/Clients/GroupsShow'),
      },
      // {
      //   path: 'page/:page?',
      //   component: () => import('@/pages/clients/ClientList'),
      //   props: (route) => ({
      //     page: Number(route.params.page) || 1
      //   })
      // },
      // {
      //   path: 'groups/page/:page?',
      //   component: () => import('@/pages/clients/ClientGroups'),
      //   props: (route) => ({
      //     page: Number(route.params.page) || 1
      //   })
      // },
      // {
      //   path: 'groups/:id/page/:page?',
      //   component: () => import('@/pages/clients/ClientGroupsShow'),
      //   props: (route) => ({
      //     page: Number(route.params.page) || 1
      //   })
      // },
    ],
  },
  {
    path: '/clients/:customerId',
    component: { render: (h) => h('router-view') },
    children: [{
      path: '',
      name: 'PageClientsShow',
      component: () => import('@/pages/associate/Clients/Show'),
    }, {
      path: 'outreach/:id',
      component: { render: (h) => h('router-view') },
      children: [{
        path: 'stats',
        name: 'associate.clients.OutreachStats',
        component: () => import('@/pages/outreachs/Stats'),
      },
      {
        path: 'activity/:event?',
        name: 'associate.clients.OutreachStatsActivity',
        component: () => import('@/pages/events/ReportActivity'),
      }],
    }],
  },
  {
    path: '/entries',
    component: () => import('@/pages/entries/Entries'),
    children: [
      {
        path: ':page?',
        name: 'PageEditorList',
        component: () => import('@/pages/entries/DraftLanding'),
        props: (route) => ({
          page: route.params.page || 1,
        }),
      },
      // {
      //   path: 'page/:page?',
      //   name: 'PageEditorList',
      //   component: () => import('@/pages/entries/List'),
      //   props: (route) => ({
      //     page: route.params.page || 1
      //   })
      // },
      {
        path: ':id/edit',
        name: 'PageEditor',
        component: () => import('@/pages/entries/Editor'),
      },
      {
        path: ':id/preview',
        name: 'PageEditorPreview',
        component: () => import('@/pages/entries/Preview'),
        meta: { hideMainMenu: true },
      },
      {
        path: ':id/library',
        name: 'Library',
        component: () => import('@/pages/entries/SentDraft'),
        meta: { isLibrary: true },
      },
      {
        path: ':id/sent',
        name: 'SentDraftSummary',
        props: true,
        component: () => import('@/pages/entries/SentDraft'),
      },
      {
        path: 'settings',
        name: 'PageEditorSettings',
        component: () => import('@/pages/entries/Settings'),
        meta: { hideMainMenu: true },
      },
    ],
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('@/pages/auth/SSOLogin'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/password-reset-confirm/:uid/:token',
    name: 'PasswordResetConfirm',
    component: () => import('@/pages/auth/PasswordResetConfirm'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/404',
    name: 'ErrorPage',
    component: () => import('@/pages/404'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/assets',
    name: 'Collateral',
    component: () => import('@/pages/collateral/Index'),
  },
  {
    path: '/assets/link/:token',
    name: 'CollateralLink',
    component: () => import('@/pages/collateral/LinkedCollateralFolder'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/album/link/:token',
    name: 'CollateralLink',
    component: () => import('@/pages/collateral/LinkedCollateralFolder'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/assets/folder',
    redirect: '/assets',
  },
  {
    path: '/assets/folder/:folderId',
    name: 'CollateralFolder',
    component: () => import('@/pages/collateral/AlbumLanding'),
    props: true,
  },
  {
    path: '/manager',
    name: 'Manager',
    redirect: '/admin',
  },
  // {
  //   path: '/team/profile/:id',
  //   name: 'Profile',
  //   component: () => import('@/pages/team/Profile')
  // },
  // {
  //   path: '/team',
  //   component: () => import('@/pages/team/Index'),
  //   children: [
  //     {
  //       path: '',
  //       name: 'Team',
  //       redirect: '/team/all',
  //     },
  //     {
  //       path: '/team/inactive',
  //       name: 'Inactive',
  //       component: () => import('@/pages/team/TeamList'),
  //       props: {
  //         filter: 'inactive',
  //       },
  //     },
  //     {
  //       path: '/team/all',
  //       name: 'All',
  //       component: () => import('@/pages/team/TeamList'),
  //       props: {
  //         filter: 'all',
  //       },
  //     },
  //   ],
  // },
  /**
   * Degt:
   * It seems this page was created to test google token
   * but I'm not sure if it's still used
   * */
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/pages/test/Test'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/oauth_outlook_redirect',
    name: 'OutlookAuthRedirect',
    component: () => import('@/pages/outlook/oauth_outlook_redirect'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/events/:id/:event',
    name: 'Events',
    component: () => import('@/pages/events/Events'),
  },
  {
    path: '/customer-activity',
    name: 'OutreachActivity',
    component: () => import('@/pages/events/ReportActivity'),
    props: ({ params: { outreach, editTitle, event } }) => ({ outreach, editTitle, event }),
  },
  {
    path: '/dashboard',
    name: 'associate.dashboard',
    component: () => import('@/pages/associate/Dashboard/Index'),
  },
  {
    path: '/reports',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '/',
        name: 'associate.reports',
        component: () => import('@/pages/associate/Reports/Index'),
        beforeEnter(to, from, next) {
          if (from.name !== 'OutreachStats') {
            store.commit('outreachs/setPage', 1);
          }
          next();
        },
      },
      {
        path: 'outreach/:id/stats',
        name: 'OutreachStats',
        component: () => import('@/pages/outreachs/Stats'),
      },
      {
        path: 'outreach/:outreach/activity/:event?',
        component: { render: (h) => h('router-view') },
        children: [{
          path: '',
          name: 'OutreachStatsActivity',
          component: () => import('@/pages/events/ReportActivity'),
        }, {
          path: 'client/:customerId',
          name: 'OutreachStatsActivity.customer',
          component: () => import('@/pages/events/ReportActivity'),
        }],
      },
      {
        path: 'appointment/:appointmentId',
        component: { render: (h) => h('router-view') },
        children: [{
          path: 'stats',
          name: 'AppointmentStats',
          component: () => import('@/pages/appointment/Stats/'),
        }, {
          path: 'activity/:event?',
          component: { render: (h) => h('router-view') },
          children: [{
            path: '',
            name: 'AppointmentActivity',
            component: () => import('@/pages/events/ReportActivity'),
          }, {
            path: 'client/:customerId',
            name: 'AppointmentActivity.customer',
            component: () => import('@/pages/events/ReportActivity'),
          }],
        }],
      },
    ],
  },
  {
    path: '/template-editor',
    name: 'TemplateEditor',
    component: () => import('@/pages/templates/Index'),
    beforeEnter(to, from, next) {
      if (store.state.account.user.user.is_staff) {
        next();
      } else next('/');
    },
    meta: { hideMainMenu: true },
  },
  {
    path: '/demo',
    name: 'demo',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: 'admin_clients',
        name: 'demo.admin.clients',
        component: () => import('@/components/MockImage'),
        props: { src: '/img/admin_clients.png' },
      },
      {
        path: 'admin_reports',
        name: 'demo.admin.reports',
        component: () => import('@/components/MockImage'),
        props: { src: '/img/admin_reports.png' },
      },
      {
        path: 'admin_collateral',
        name: 'demo.admin.collateral',
        component: () => import('@/components/MockImage'),
        props: { src: '/img/admin_collateral.png' },
      },
      {
        path: 'admin_dashboard',
        name: 'demo.admin.dashboard',
        component: () => import('@/components/MockImage'),
        props: { src: '/img/admin_dashboard.png' },
      },

    ],
  },
  {
    path: '/appointments',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'appointments',
        component: () => import('@/pages/appointment/Index'),
      },
      {
        path: ':id/view',
        name: 'appointments.view',
        component: () => import('@/pages/appointment/View'),
      },
      {
        path: ':id/view/guests/:type',
        name: 'appointments.guest-report',
        component: () => import('@/pages/appointment/GuestReport'),
      },
      {
        path: ':id/edit',
        name: 'appointments.edit',
        component: () => import('@/pages/appointment/Show'),
      },
      {
        path: 'create',
        name: 'appointments.create',
        component: () => import('@/pages/appointment/Show'),
      },
    ],
  },
  {
    path: '/appointment/:id/',
    component: () => import('@/pages/appointment/VideoRoom'),
    meta: { hideMainMenu: true },
  },
  {
    path: '/inventory',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        name: 'catalog.index',
        component: () => import('@/pages/catalog/Index'),
      },
      {
        path: ':id',
        name: 'catalog.show',
        component: () => import('@/pages/catalog/Show'),
      },
    ],
  },
  {
    path: '/admin',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: '',
        redirect: '/admin/dashboard',
      },
      {
        path: 'dashboard',
        name: 'admin.dashboard',
        component: () => import('@/pages/admin/Dashboard'),
      },
      {
        path: 'team',
        name: 'admin.team',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: 'add',
            name: 'admin.team.addTeamMember',
            component: () => import('@/pages/admin/team/AddTeamMember'),
          },
          {
            path: ':id',
            name: 'admin.team.show',
            component: () => import('@/pages/admin/team/Show'),
          },
          {
            path: ':id/manage-clients',
            name: 'admin.team.manageClients',
            component: () => import('@/pages/admin/team/ManageClients'),
          },
          {
            path: ':id/manage-groups',
            name: 'admin.team.manageGroups',
            component: () => import('@/pages/admin/team/ManageGroups'),
          },
          {
            path: ':id/add-clients',
            name: 'admin.team.addClients',
            component: () => import('@/pages/admin/team/AddClients'),
          },
          {
            path: ':profile_id/group/:id',
            name: 'stylist.group',
            component: () => import('@/pages/admin/team/StylistGroup'),
          },
        ],
      },
      {
        path: 'clients',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: '',
            name: 'admin.clients',
            component: () => import('@/pages/admin/clients/Index'),
          },
          {
            path: 'groups',
            name: 'admin.groups',
            component: () => import('@/pages/associate/Clients/Groups'),
          },
          {
            path: 'groups/:id',
            name: 'admin.groups.show',
            component: () => import('@/pages/associate/Clients/GroupsShow'),
          },
        ],
      },
      {
        path: 'clients/:customerId',
        component: { render: (h) => h('router-view') },
        children: [{
          path: '',
          name: 'admin.clients.show',
          component: () => import('@/pages/admin/clients/Show'),
        }, {
          path: 'outreach/:id',
          name: 'admin.clients.OutreachStats',
          component: { render: (h) => h('router-view') },
          children: [{
            path: 'stats',
            name: 'admin.clients.OutreachStats',
            component: () => import('@/pages/outreachs/Stats'),
          },
          {
            path: 'activity/:event?',
            name: 'admin.clients.OutreachStatsActivity',
            component: () => import('@/pages/events/ReportActivity'),
          }],
        }],
      },
      {
        path: 'reports',
        component: { render: (h) => h('router-view') },
        children: [
          {
            path: '',
            name: 'admin.reports',
            component: () => import('@/pages/admin/reports/Index'),
            beforeEnter(to, from, next) {
              if (from.name !== 'admin.OutreachStats') {
                store.commit('outreachs/setPage', 1);
              }
              next();
            },
          },
          {
            path: ':id',
            name: 'admin.reports.show',
            component: () => import('@/pages/admin/reports/Show'),
          },
          {
            path: 'outreach/:id/stats',
            name: 'admin.OutreachStats',
            component: () => import('@/pages/outreachs/Stats'),
          },
          {
            path: 'outreach/:outreach/activity/:event?',
            component: { render: (h) => h('router-view') },
            children: [{
              path: '',
              name: 'admin.OutreachStatsActivity',
              component: () => import('@/pages/events/ReportActivity'),
            }, {
              path: 'client/:customerId',
              name: 'admin.OutreachStatsActivity.customer',
              component: () => import('@/pages/events/ReportActivity'),
            }],
          },
          {
            path: 'appointment/:appointmentId',
            component: { render: (h) => h('router-view') },
            children: [{
              path: 'stats',
              name: 'AppointmentStats',
              component: () => import('@/pages/appointment/Stats/'),
            }, {
              path: 'activity',
              name: 'AppointmentActivity',
              component: () => import('@/pages/events/ReportActivity'),
            }],
          },
        ],
      },
      {
        path: 'appointments',
        name: 'admin.appointments',
        component: () => import('@/pages/appointment/Index'),
      },
    ],
  },
  {
    path: '/salesforce',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: 'auth_init',
        name: 'salesforce.auth_init',
        component: () => import('@/pages/salesforce/AuthInit'),
        meta: { hideMainMenu: true },
      },
      {
        path: 'auth_callback',
        name: 'salesforce.auth_callback',
        component: () => import('@/pages/salesforce/AuthCallback'),
        meta: { hideMainMenu: true },
      },
      {
        path: 'oauth_login',
        name: 'salesforce.oauth_login',
        component: () => import('@/pages/salesforce/Oauth2Init'),
        meta: { hideMainMenu: true },
      },
      {
        path: 'oauth_callback',
        name: 'salesforce.oauth_callback',
        component: () => import('@/pages/salesforce/Oauth2Callback'),
        meta: { hideMainMenu: true },
      },
    ],
  },
  /**
   * Route used to log the chrome-extension
   */
  {
    path: '/extension-login',
    component: { render: (h) => h('div') },
    meta: { hideMainMenu: true },
  },
  {
    path: '/shopify',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: 'init_store',
        name: 'shopify.init',
        component: () => import('@/pages/shopify/StoreInit'),
        meta: { hideMainMenu: true },
      },
    ],
  },
  {
    path: '/burberry',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: 'callback',
        name: 'burberry.callback',
        component: () => import('@/pages/burberry/Callback'),
        meta: { hideMainMenu: true },
      },
    ],
  },
  {
    path: '*',
    redirect: '/404',
  },
];
